module.exports = __webpack_public_path__ + "img/kefu.1fb62a76.jpeg";